import React from 'react';
import twitterIcon from '../assets/xLogo.svg';

const SocialMediaSection = () => {
  const socialMediaLinks = [
    { icon: twitterIcon, url: 'https://www.x.com/deepnodee', alt: 'Twitter' },
  ];

  return (
    <div style={styles.container}>
      {/* <h2 style={styles.title}>Follow Us</h2> */}
      <div style={styles.iconsContainer}>
        {socialMediaLinks.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
          >
            <img src={link.icon} alt={link.alt} style={styles.icon} />
          </a>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '80px 0px',
    // backgroundColor: '#111', // Adjust to match your theme
    // borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    marginTop: '-12rem', // If you must use negative margin
    zIndex: 10, // Ensure it renders on top
    position: 'relative', // Required for z-index to take effect
  },
  title: {
    color: '#fff',
    fontSize: 'clamp(18px, 2.5vw, 24px)',
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    marginBottom: '20px',
  },
  iconsContainer: {
    display: 'flex',
    gap: '0px',
  },
  link: {
    display: 'block',
    width: '40px',
    height: '40px',
    transition: 'transform 0.3s ease',
  },
  icon: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
};

export default SocialMediaSection;
